export enum UserRole {
  Admin = 'Admin',
  RO_PP_Poweruser = 'RO_PP_Poweruser',
  RO_PP_Worker = 'RO_PP_Worker',
  RO_PP_Finance = 'RO_PP_Finance',
  RO_Project_Manager = 'RO_Project_Manager',
  RO_Construction_Manager = 'RO_Construction_Manager',
  EPG_Supervisor = 'EPG_Supervisor',
  EPG_Engineer = 'EPG_Engineer',
  EPG_Construction_Manager = 'EPG_Construction_Manager',
  EPG_Project_Manager = 'EPG_Project_Manager',
  EPG_Worker = 'EPG_Worker',
  EPG_Finance = 'EPG_Finance',
  Partner_User = 'partneruser',
  Supplier_Worker = 'Supplier_Worker',
  Supplier_Manager = 'Supplier_Manager',
  Supplier_Project_Manager = 'Supplier_Project_Manager',
  Supplier_User = 'Supplier_User',
}
